import { LDClient, LDFlags } from '~/providers';
import { addFileProps } from '~/utils/files';
import { LMIProofDoc } from '../component/lmi-proof-docs-upload.component';
import { convertImageToPdf } from '../image-to-pdf';

interface HandleUploadParams {
  file: File;
  base64Image: string;
  documentType: string;
}

export const handleUpload = async ({
  file,
  base64Image,
  documentType,
}: HandleUploadParams): Promise<LMIProofDoc> => {
  const proofDocTypesThatRequirePdf = LDClient.variation(LDFlags.ffProofDocTypeRequirePdf) || [];
  if (!proofDocTypesThatRequirePdf.includes(documentType)) {
    return {
      documentType,
      image: addFileProps(file, base64Image),
    };
  }
  const pdfBase64 = await convertImageToPdf(base64Image);
  const pdfFile = new File([pdfBase64], file.name.replace(/\.[^/.]+$/, '.pdf'), {
    type: 'application/pdf',
  });

  return {
    documentType,
    image: addFileProps(pdfFile, pdfBase64),
  };
};
